module.exports = __webpack_public_path__ + "img/flag_128.8fdda704.png";